__webpack_require__.p = "https://stagingnext.hellotech.com/_next/";